module.exports = __webpack_public_path__ + "730b98bc0d85327c2655bbbe615bd8e1.svg";